export default "__VITE_ASSET__CNiS6vI9__"